// @flow

import * as React from 'react'

export default class Baidu extends React.PureComponent<any> {
  componentWillMount () {
    loadBaiduAd()
  }

  render () {
    return null
  }
}

function loadBaiduAd () {
  /* eslint-disable */
  (function(root) {
    root._hmt = root._hmt || [];
    (function() {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?71c824618d8a3d378aedf9a4f045c68e';
      var s = document.getElementsByTagName('script')[0];
      //$FlowFixMe
      s.parentNode.insertBefore(hm, s);
    })();
    /* eslint-enable */
  })(window)
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/Baidu.js